// 基准大小
const baseSize = 65;

// 设置 rem 函数
function setRem() {
  // 获取当前窗口宽度
  const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

  // 根据窗口宽度判断设备类型
  let scale;
  if (windowWidth > 500) {
    scale = windowWidth / 1500; // 电脑窗口
  } else {
    scale = windowWidth / 750; // 手机窗口
  }

  // 设置页面根节点字体大小
  document.documentElement.style.fontSize = (baseSize * Math.min(scale, 2)) + 'px';
}

// 初始化
setRem();

// 改变窗口大小时重新设置 rem
window.onresize = function () {
  setRem();
};